import React from 'react';
import { useParams } from 'react-router-dom';
import { useCart } from '../context/CartContext.jsx';
import './ProductDetail.css';

function ProductDetail() {
  const { productId } = useParams();
  const { addToCart } = useCart();

  // This would typically come from a database or API
  const productDetails = {
    'lamp-base': {
      id: 'lamp-base',
      name: 'lamp base',
      price: '$25 AUD',
      description: 'a versatile base for your custom lamp design',
      features: [
        'compatible with all illuma 3D lamp designs',
        'sturdy construction',
        'compatible with all lamp designs',
        'easy to assemble'
      ],
      specifications: {
        dimensions: '15cm x 15cm x 30cm',
        weight: '1.2kg',
        material: 'aluminum',
        color: 'matte black'
      }
    },
    'lamp-design-01': {
      id: 'lamp-design-01',
      name: 'lamp design 01',
      price: '$90 AUD',
      description: 'a modern, minimalist lamp design with geometric patterns',
      features: [
        'geometric pattern design',
        'creates beautiful light patterns',
        'easy to assemble',
        'sustainable materials'
      ],
      specifications: {
        dimensions: '30cm x 30cm x 40cm',
        weight: '2.4kg',
        material: 'recycled aluminum',
        color: 'matte black'
      }
    },
    'lamp-design-02': {
      id: 'lamp-design-02',
      name: 'lamp design 02',
      price: '$90 AUD',
      description: 'an organic, flowing design inspired by natural forms',
      features: [
        'organic flowing design',
        'creates soft, ambient lighting',
        'easy to assemble',
        'sustainable materials'
      ],
      specifications: {
        dimensions: '35cm x 35cm x 45cm',
        weight: '2.8kg',
        material: 'recycled aluminum',
        color: 'matte black'
      }
    },
    'lamp-design-03': {
      id: 'lamp-design-03',
      name: 'lamp design 03',
      price: '$90 AUD',
      description: 'a contemporary design featuring interlocking geometric shapes',
      features: [
        'interlocking geometric design',
        'creates dynamic light patterns',
        'easy to assemble',
        'sustainable materials'
      ],
      specifications: {
        dimensions: '32cm x 32cm x 42cm',
        weight: '2.6kg',
        material: 'recycled aluminum',
        color: 'matte black'
      }
    }
  };

  const product = productDetails[productId];

  if (!product) {
    return <div className="product-detail">Product not found</div>;
  }

  return (
    <div className="product-detail">
      <div className="product-header">
        <h1>{product.name}</h1>
        <p className="product-price">{product.price}</p>
      </div>

      <div className="product-content">
        <div className="product-image"></div>
        
        <div className="product-info">
          <p className="product-description">{product.description}</p>
          
          <div className="product-features">
            <h2>FEATURES</h2>
            <ul>
              {product.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>

          <div className="product-specifications">
            <h2>SPECIFICATIONS</h2>
            <div className="specs-grid">
              <div className="spec-item">
                <span className="spec-label">dimensions</span>
                <span className="spec-value">{product.specifications.dimensions}</span>
              </div>
              <div className="spec-item">
                <span className="spec-label">weight</span>
                <span className="spec-value">{product.specifications.weight}</span>
              </div>
              <div className="spec-item">
                <span className="spec-label">material</span>
                <span className="spec-value">{product.specifications.material}</span>
              </div>
              <div className="spec-item">
                <span className="spec-label">color</span>
                <span className="spec-value">{product.specifications.color}</span>
              </div>
            </div>
          </div>

          <button 
            className="add-to-cart-button"
            onClick={() => addToCart(product)}
          >
            add to cart
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail; 